import { ConfettiHandler } from './ConfettiHandler';
export const confettiHandler = new ConfettiHandler(window);
export default confettiHandler;
